module.exports = __webpack_public_path__ + "static/media/ACALOGO(wURL)_300w_1730987758432.5e5133a5.eps";